module.exports = __webpack_public_path__ + "media/images/homes/TableManagement-f590c0ab328c23ffac33aebebcd4af8b.png";